import { useState } from "react";
import Button from "ui/buttons/Button";
import ConfirmModal from "./ConfirmModal";

## Basic Usage

export function BasicConfirmModal() {
  const [open, setOpen] = useState(false);
  const handleConfirm = (e) => {
    e.preventDefault();
    alert("Confirmed!");
    setOpen(false);
  };
  return (
    <>
      <Button onClick={() => setOpen(true)}>Open Confirm Modal</Button>
      <ConfirmModal
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={handleConfirm}
        title="Confirm Action"
        message="Are you sure you want to proceed with this action?"
      />
    </>
  );
}

<BasicConfirmModal />
